export enum EnumViewMode {
  LIST = "list",
  MAP = "map",
  GRID = "grid",
  CARD = "card",
  TABLE = "table",
}
